import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import { message } from "antd";
import { ApiResponse } from "@/types";
import { networkConfig } from "@/config/networkConfig";

// 创建axios实例
const api: AxiosInstance = axios.create({
  baseURL: networkConfig.apiBaseUrl,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// 请求拦截器
api.interceptors.request.use(
  (config) => {
    // 添加认证Token
    const token = localStorage.getItem("mslogin_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
api.interceptors.response.use(
  (response: AxiosResponse<ApiResponse>) => {
    return response;
  },
  (error) => {

    // 处理HTTP错误状态码
    if (error.response) {
      const { status, data } = error.response;

      switch (status) {
      case 401:
        // 未认证，清除本地存储并跳转到登录页
        // 检查是否在iframe中，如果是则不执行清除操作
        if (window.parent === window) {
          localStorage.removeItem("mslogin_token");
          localStorage.removeItem("mslogin_user");
          window.location.href = "/login";
          message.error("登录已过期，请重新登录");
        }
        break;
      case 403:
        message.error(data?.message || "权限不足");
        break;
      case 404:
        message.error("请求的资源不存在");
        break;
      case 500:
        message.error("服务器内部错误");
        break;
      default:
        message.error(data?.message || "请求失败");
      }
    } else if (error.request) {
      // 网络错误
      message.error("网络连接失败，请检查网络设置");
    } else {
      // 其他错误
      message.error("请求配置错误");
    }

    return Promise.reject(error);
  }
);

// 通用请求方法
export const request = {
  get: <T = any>(url: string, config?: AxiosRequestConfig): Promise<ApiResponse<T>> => {
    return api.get(url, config).then(response => response.data);
  },

  post: <T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<ApiResponse<T>> => {
    return api.post(url, data, config).then(response => response.data);
  },

  put: <T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<ApiResponse<T>> => {
    return api.put(url, data, config).then(response => response.data);
  },

  delete: <T = any>(url: string, config?: AxiosRequestConfig): Promise<ApiResponse<T>> => {
    return api.delete(url, config).then(response => response.data);
  },

  patch: <T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<ApiResponse<T>> => {
    return api.patch(url, data, config).then(response => response.data);
  }
};

export default api;
